var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"blueberry-icon",attrs:{"src":require(("../../public/icons/" + _vm.name + ".svg")),"alt":_vm.name}})}
var staticRenderFns = []

export { render, staticRenderFns }